import { COL_LOCATION, COL_STATUS, ISSUE_TABLE_COLS } from './issue-table-grid'

const TH = 'text-[10.5px] font-bold uppercase tracking-[.06em] text-gis-heading'

/** Column header for the Issues List table (List view only). Optional columns carry the same
 *  `@container/list` visibility classes as their row cells (see issue-table-grid.ts). */
export function IssuesListHeaderRow() {
  return (
    <div className={`${ISSUE_TABLE_COLS} border-b border-gis-line-2 px-3 py-[7px]`}>
      <span className={TH}>Issue</span>
      <span className={`${TH} ${COL_LOCATION}`}>Location</span>
      <span className={`${TH} ${COL_STATUS}`}>Status</span>
      <span className={`${TH} text-right`}>Age</span>
      <span />
    </div>
  )
}
